import { useMutation, } from "@tanstack/react-query";
export const createNewsletterSubscriptionsQueries = (requests, queryClient) => ({
    useCreateNewsletterSubscription: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createNewsletterSubscription,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map